<script lang="ts">
	//Helpers
	import { getDeviceStatus } from 'src/stores/device-runtime/status-selectors';
	import { real_id } from 'src/helpers/interface_helpers';
	import { LabelList, LabelListV2 } from '@Shelly/shelly-design-system';
	import { showNewLayout } from 'src/stores/toDelete/new_layout';
	import { mapIconSolidWeightToLight, mapLegacyColorToToken } from 'src/helpers/new-layout-helpers';
	import { getRoomMainLabel } from 'src/helpers/room_label_list_helpers';
	//Types
	import type { Room } from 'src/types/Room';

	export let item: Room;

	$: mainSensorStatusStore = item?.main_sensor ? getDeviceStatus(item.main_sensor) : undefined;
	$: mainSensorStatus = mainSensorStatusStore ? $mainSensorStatusStore : undefined;
	$: statusMap =
		item?.main_sensor && mainSensorStatus
			? { [real_id(item.main_sensor)]: mainSensorStatus }
			: {};
	$: labelList = getRoomMainLabel(item, statusMap);
</script>

{#if !$showNewLayout}
	<LabelList {labelList} size="xl" bgOpacity on:label-click />
{:else}
	<LabelListV2
		a11yProps={{ isInteractive: true }}
		labelList={labelList.map((el) => ({
			...el,
			icon: mapIconSolidWeightToLight(el?.icon),
			backgroundColor: mapLegacyColorToToken(el?.type),
		})) || []}
		size="xl"
		on:label-click
	/>
{/if}
